import { FaUsers, FaClock, FaStar, FaBook, FaArrowRight } from "react-icons/fa";
import styles from "./OnlineHero.module.css";

const OnlineHero = () => {
  const stats = [
    { icon: <FaUsers />, value: "1000+", label: "Active Students" },
    { icon: <FaClock />, value: "24/7", label: "Support Available" },
    { icon: <FaStar />, value: "4.9", label: "Average Rating" },
    { icon: <FaBook />, value: "50+", label: "Courses" },
  ];

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className={styles.hero}>
      <div className={styles.content}>
        <div className={styles.mainContent}>
          <h1>
            Elevate Your Skills with{" "}
            <span className={styles.highlight}>STEMx Live 1-on-1 Sessions</span>
          </h1>
          <p>
            Fully hands-on, Personalized 1-on-1 sessions designed to spark creativity and skills in <strong>Coding</strong>, <strong>Virtual LEGO Robotics</strong>, as well as<strong> Robotics with Hardware kits</strong>, <strong>3D Design</strong>, <strong>AI</strong>,<strong> Programming</strong>, <strong>App Development</strong>, <strong>Animation</strong>, <strong>Storytelling</strong>, <strong>Graphic Design</strong >and <strong>Virtual Electronics</strong>.
          </p>
        </div>

        <div className={styles.buttons}>
          <button
            onClick={() => scrollToSection("cta-form")}
            className={styles.primary}
          >
            Enroll Now <FaArrowRight />
          </button>
          <button
            onClick={() => scrollToSection("programs-offered")}
            className={styles.secondary}
          >
            Learn More
          </button>
        </div>

        <div className={styles.statsGrid}>
          {stats.map((stat, index) => (
            <div key={index} className={styles.quickStat}>
              <div className={styles.statIcon}>{stat.icon}</div>
              <div className={styles.statValue}>{stat.value}</div>
              <div className={styles.statLabel}>{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OnlineHero;
